import { Component } from '@angular/core';

@Component({
  selector: 'app-blank-layout',
  standalone: false,
  templateUrl: './blank-layout.component.html',
  styleUrl: './blank-layout.component.css'
})
export class BlankLayoutComponent {

}
